import React, { useEffect, useState } from 'react'
import { INFDetailFormatted } from '../../../components/NFTDetail/INFTDetail'
import Api from '../../../../../services/Api'
import INFTProperties, { IBaseNFTAttributes } from '../../../models/INFTProperties'
import BaseDetail from '../../Base/Detail/BaseDetail'
import { IDeproApeCryptoClubCard } from '../Card/IDeproApeCryptoClubCard'
import NFTImageSkeleton from '../../../components/NFTImageSkeleton'

export default function DeproApeCryptoClubDetail(props: INFDetailFormatted) {
  const { tokenItem, collection } = props
  const [detailTokenItem, setDetailTokenItem] = useState<IDeproApeCryptoClubCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)

  const tokenName = detailTokenItem ? `${collection.name} #${tokenItem.tokenId}` : collection.name
  useEffect(() => {
    let newTokenUri = ''
    if (tokenItem) {
      if (tokenItem.tokenUri) {
        newTokenUri = tokenItem.tokenUri.replace('ipfs://', 'https://ipfs.io/ipfs/')
      } else {
        newTokenUri = `https://ipfs.io/ipfs/QmeSjSinHpPnmXmspMjwiXyN6zS4E9zccariGR3jxcaWtq/${tokenItem.tokenId}`
      }
    }

    if (tokenItem && tokenItem.tokenId !== undefined && newTokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(newTokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  function getNFTProperties() {
    let result: INFTProperties[] = []

    if (detailTokenItem) {
      result = detailTokenItem.attributes.map((item: IBaseNFTAttributes) => ({
        key: item.trait_type,
        value: item.value
      }))
    }

    return result
  }

  function getNFTDescription() {
    return (
      <div>
        What is DeproApeCryptoClub?
        <p>
          The Apes Club has arrived on #Avalanche! Our collection is a set of 5000 algorithmically generated but cloned
          apes inspired by @BAYC. What will happen once they’ve lived on Avalanche? Missed your chance on Eth? Let’s go
        </p>
      </div>
    )
  }

  return (
    <BaseDetail {...props} description={getNFTDescription()} tokenItemName={tokenName} properites={getNFTProperties()}>
      {detailTokenItem ? (
        <img src={detailTokenItem.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} alt={tokenName} />
      ) : (
        <NFTImageSkeleton />
      )}
    </BaseDetail>
  )
}
